import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ListView from '../Common/ListView.react';
import ListItem from './OrganisationListItem';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';

import OrganisationActions from '../../actions/OrganisationActionCreator';
import OrganisationStore from '../../stores/OrganisationStore';

import buildContextMenu from '../Common/BuildContextMenu';

class OrganisationList extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            organisations: OrganisationStore.getAll(),
            actions: [],
            count: 0,
            page: 0,
            limit: 50,
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        OrganisationStore.addChangeListener(this.onChange);
        OrganisationActions.getAll();
        this.setState({actions: buildContextMenu(this.getActions(), this.context.auth)});
    }

    componentWillUnmount() {
        OrganisationStore.removeChangeListener(this.onChange);
    }

    getActions() {
        return [
            {
                link: '/logout',
                icon: <CancelIcon />,
                label: 'Sign out',
            },
        ];
    }

    render() {
        return (
            <ListView
                title="Organisations"
                sortOptions={this.props.sortOptions}
                sortAction={OrganisationActions.getAll}
                searchAction={OrganisationActions.search}
                minSearchTextSize={3}
                actions={this.state.actions}
                items={this.state.organisations}
                itemDecorator={ListItem}
                newEntityUrl={this.context.auth.isRootAdmin() ? '/dashboard/organisation/new' : ''}
            />
        );
    }

    onChange() {
        this.setState({organisations: OrganisationStore.getAll()});
    }
}

OrganisationList.defaultProps = {
    sortOptions: [
        {label: "Name", value: 'name'},
        {label: "Created", value: 'dateAdded'}
    ]
};

OrganisationList.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default OrganisationList;
